import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import * as NavActions from '../../components/paramHistory/store/actions';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers'; 
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
});

class InstructorList extends Component {

    componentDidMount() {
        this.props.getInstructorList();
    }

    handleRowClick(page_type, instructor_id) {
        this.props.history.push(`/instructor/${page_type}/${instructor_id}`);
    }

    handleAddNew = () => {
        this.props.updateAuthPreloadRole({ active: true, role: { RoleName: 'Instructor', role_id: 3 } })
        return this.props.history.push("/user/create")
    }

    render() {
        const { classes, instructorList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type = {"instructor"}
                        view_type      = {"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name = {"instructor"}
                            view_type      = {"list"}
                            button_list    = {[
                                {
                                    display: "Add",
                                    type:    "create",
                                    color:   "primary",
                                    onClick: () => this.handleAddNew(),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "First Name",
                                accessor: "FirstName"
                            },
                            {
                                Header: "Last Name",
                                accessor: "LastName"
                            },
                            {
                                Header: "Email",
                                accessor: "Email",
                            },
                            {
                                Header: "Actions",
                                maxWidth: 150,
                                Cell: row => (
                                    <div className="flex items-center">
                                        <Tooltip title="Detail">
                                            <IconButton
                                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleRowClick('detail', row.original.instructor_id);
                                                }}
                                            >
                                                <Icon>library_books</Icon>
                                            </IconButton>
                                        </Tooltip>
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "instructor", "edit") ? null :
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.handleRowClick('edit', row.original.instructor_id);
                                                    }}
                                                >
                                                    <Icon>border_color</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                )
                            }
                        ]}
                        data={instructorList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Instructors Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInstructorList:     Actions.getInstructorList,
        setTableSort:          TableActions.setTableSort,
        setTableFilter:        TableActions.setTableFilter,
        setTablePageSize:      TableActions.setTablePageSize,
        updateAuthPreloadRole: NavActions.updateAuthPreloadRole
    }, dispatch);
}

function mapStateToProps({ auth, instructorApp, tableSort }) {
    return {
        auth,
        instructorList:  instructorApp.instructors.instructorList,
        table_sort:      tableSort.table_sort,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorList)));


// WEBPACK FOOTER //
// src/main/content/instructor/InstructorList.js